/**
 * Core Web Vitals Monitoring
 * Tracks LCP, FID, CLS, INP, and TTFB using PerformanceObserver
 * Logs to console in development; can be extended to send to analytics
 */
(function () {
  'use strict';

  var vitals = {};

  // Largest Contentful Paint (LCP)
  if ('PerformanceObserver' in window) {
    try {
      var lcpObserver = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        var lastEntry = entries[entries.length - 1];
        vitals.LCP = Math.round(lastEntry.startTime);
      });
      lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) { /* LCP not supported */ }

    // First Input Delay (FID)
    try {
      var fidObserver = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        if (entries.length > 0) {
          vitals.FID = Math.round(entries[0].processingStart - entries[0].startTime);
        }
      });
      fidObserver.observe({ type: 'first-input', buffered: true });
    } catch (e) { /* FID not supported */ }

    // Cumulative Layout Shift (CLS)
    try {
      var clsValue = 0;
      var clsEntries = [];
      var sessionValue = 0;
      var sessionEntries = [];

      var clsObserver = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];

            if (sessionValue &&
              entry.startTime - lastSessionEntry.startTime < 1000 &&
              entry.startTime - firstSessionEntry.startTime < 5000) {
              sessionValue += entry.value;
              sessionEntries.push(entry);
            } else {
              sessionValue = entry.value;
              sessionEntries = [entry];
            }

            if (sessionValue > clsValue) {
              clsValue = sessionValue;
              clsEntries = sessionEntries.slice();
              vitals.CLS = Math.round(clsValue * 1000) / 1000;
            }
          }
        });
      });
      clsObserver.observe({ type: 'layout-shift', buffered: true });
    } catch (e) { /* CLS not supported */ }

    // Interaction to Next Paint (INP)
    try {
      var inpValue = 0;
      var inpObserver = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.interactionId) {
            var duration = entry.duration;
            if (duration > inpValue) {
              inpValue = duration;
              vitals.INP = Math.round(duration);
            }
          }
        });
      });
      inpObserver.observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (e) { /* INP not supported */ }
  }

  // Time to First Byte (TTFB)
  if ('performance' in window && performance.getEntriesByType) {
    var navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0) {
      vitals.TTFB = Math.round(navEntries[0].responseStart);
    }
  }

  // Report on page visibility change (user navigates away)
  function reportVitals() {
    // Thresholds (good / needs improvement / poor)
    var thresholds = {
      LCP: [2500, 4000],
      FID: [100, 300],
      CLS: [0.1, 0.25],
      INP: [200, 500],
      TTFB: [800, 1800]
    };

    var report = [];
    Object.keys(vitals).forEach(function (key) {
      var val = vitals[key];
      var t = thresholds[key];
      var rating = 'good';
      if (t) {
        if (val > t[1]) rating = 'poor';
        else if (val > t[0]) rating = 'needs-improvement';
      }
      report.push(key + ': ' + val + (key === 'CLS' ? '' : 'ms') + ' (' + rating + ')');
    });

    if (report.length > 0) {
      // console.log('%c[Web Vitals]', 'color: #ff6b3d; font-weight: bold', report.join(' | '));
    }

    // Extension point: send to analytics endpoint
    // Example: navigator.sendBeacon('/analytics', JSON.stringify(vitals));
  }

  // Report when page is hidden (most reliable timing)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      reportVitals();
    }
  });

  // Also report after a delay for single-page visits
  setTimeout(reportVitals, 10000);

  // Expose for debugging
  window.__webVitals = vitals;
})();
